import { render, staticRenderFns } from "./edit-information.vue?vue&type=template&id=19fc70bd&scoped=true"
import script from "./edit-information.vue?vue&type=script&lang=js"
export * from "./edit-information.vue?vue&type=script&lang=js"
import style0 from "./edit-information.vue?vue&type=style&index=0&id=19fc70bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fc70bd",
  null
  
)

export default component.exports